<template>
  <div style="background: #fff;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Support</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin:26px 139px 0 139px;height: auto;position:relative">
      <img src="../assets/support_search.png" style="width:28px;height:28px;position:absolute;left:25px;top:18px;z-index:2;">
      <el-input class="search_input" clearable v-model="keybords" @change="changeValue" placeholder="Please enter a keyword."></el-input>
      <!-- <el-input prefix-icon="el-icon-search" class="search_input" clearable v-model="keybords" @change="changeValue" placeholder="Please enter a keyword."></el-input> -->
    </div>
    <div class="support_content">
      <div class="support_item">
        <div class="support_title">
          <span>Software Updates</span>
          <img style="margin-left:8px" src="../assets/lock_icon.png">
        </div>
        <div class="support_mesg">
          <div style="display:flex;justify-content: space-between;line-height:42px;" v-for="(item, index) in SoftwareUpdates" :key="index">
            <div>
              <a class="a1">
                <img src="../assets/dot_icon.png">
                <span style="margin:0 18px 0 20px ;">{{ item.name }}</span>
                <img @click="goDownload(item.path)" src="../assets/down_icon.png">
              </a>
            </div>
            <!-- <div>{{ item.created }}</div> -->
          </div>
        </div>
      </div>
      <div class="support_item">
        <div class="support_title">Datasheet</div>
        <div class="support_mesg">
          <div style="display:flex;justify-content: space-between;line-height:42px;" v-for="(item, index) in Datasheet" :key="index">
            <div>
              <a class="a1">
                <img src="../assets/dot_icon.png">
                <span style="margin:0 18px 0 20px ;">{{ item.name }}</span>
                <img @click="goDownload(item.path)" src="../assets/down_icon.png">
              </a>
            </div>
            <!-- <div>{{ item.created }}</div> -->
          </div>
        </div>
      </div>
      <div class="support_item">
        <div class="support_title">Manuals</div>
        <div class="support_mesg">
          <div style="display:flex;justify-content: space-between;line-height:42px;" v-for="(item, index) in Manuals" :key="index">
            <div>
              <a class="a1">
                <img src="../assets/dot_icon.png">
                <span style="margin:0 18px 0 20px ;">{{ item.name }}</span>
                <img @click="goDownload(item.path)" src="../assets/down_icon.png">
              </a>
            </div>
            <!-- <div>{{ item.created }}</div> -->
          </div>
        </div>
      </div>
      <div class="support_item">
        <div class="support_title">Application Notes</div>
        <div class="support_mesg">
          <div style="display:flex;justify-content: space-between;line-height:42px;" v-for="(item, index) in ApplicationNotes" :key="index">
            <div>
              <a class="a1">
                <img src="../assets/dot_icon.png">
                <span style="margin:0 18px 0 20px ;">{{ item.name }}</span>
                <img @click="goDownload(item.path)" src="../assets/down_icon.png">
              </a>
            </div>
            <!-- <div>{{ item.created }}</div> -->
          </div>
        </div>
      </div>
      <div class="support_item">
        <div class="support_title">Tools</div>
        <div class="support_mesg">
          <div style="display:flex;justify-content: space-between;line-height:42px;" v-for="(item, index) in Tools" :key="index">
            <div>
              <a class="a1">
                <img src="../assets/dot_icon.png">
                <span style="margin:0 18px 0 20px ;">{{ item.name }}</span>
                <img @click="goDownload(item.path)" src="../assets/down_icon.png">
              </a>
            </div>
            <!-- <div>{{ item.created }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { supportList, searchSupport } from '@/api/index' ;
    export default {
        name: 'Support',
        data () {
            return {
              keybords: '',
              Datasheet: [],
              SoftwareUpdates: [],
              ApplicationNotes: [],
              Manuals: [],
              Tools: [],
            }
        },
        mounted() {
          this.getSupportList();
        },
        methods: {
          // 获取support
          getSupportList() {
              const params = {};
              supportList(params).then((res) => {
                console.log(res, 'supportList');
                  this.Datasheet = res.Datasheet;
                  this.SoftwareUpdates = res.SoftwareUpdates;
                  this.ApplicationNotes = res.ApplicationNotes;
                  this.Manuals = res.Manuals;
                  this.Tools = res.Tools;
              });
          },
          // 获取support 模糊搜索
          getSearchSupport(val) {
              const params = {
                keywords: val
              };
              searchSupport(params).then((res) => {
                console.log(res, 'searchSupport');
                  this.Datasheet = res.Datasheet;
                  this.SoftwareUpdates = res.SoftwareUpdates;
                  this.ApplicationNotes = res.ApplicationNotes;
                  this.Manuals = res.Manuals;
                  this.Tools = res.Tools;
              });
          },
          changeValue(val) {
            this.keybords = val;
            this.getSearchSupport(val);
          },
          // 下载
          goDownload(val){
            window.open(val);
          },
        },
    }
</script>

<style scoped>
/* 内容标题设计稿上是24号字体 */
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
  font-weight:400;
}
.search_input {
  /* margin: 0 139px 0 139px; */
  width: 100%;
}
.el-input {
  /* width: 80%; */
}
::v-deep .el-input__inner {
  height: 60px !important;
  line-height: 60px !important;
  border-radius:10px !important;
  width: 100%;
  background-color: #f5f5f5 !important;
  border: none !important;
}
.support_content {
  margin-top:31px;
  margin-bottom: 46px;
  width: 100%;
  height: auto;
  font-family: Arial;
}
.support_item {
  margin: 0 139px 34px 139px;
}
.support_title {
  height: 56px;
  line-height: 56px;
  border-radius: 10px 10px 0 0;
  background-color:#f5f5f5;
  color:#00546a;
  font-size: 22px;
  font-weight: bold;
  padding-left: 20px;
}
.support_mesg {
  border-radius: 0 0 10px 10px;
  padding: 35px 40px 15px 46px;
  border: 1px solid #f5f5f5;
  color: #343434;
  font-size: 20px;
  box-shadow:0px 2px 2px 0 #f5f5f5;
  font-weight: 400;
}
.support_mesg p {
  line-height: 23px;
  margin-bottom: 24px;
}
::v-deep .el-input__inner {
  padding-left:90px;
}
/* .el-input__icon {
  background-image: url('../assets/support_search.png') !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  width:28px;
  height:28px;
} */
/* ::v-deep .el-icon-search:before{
  content: '';
} */
::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>